var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 28,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M 0 0 h 27 V 15.6 H 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M 0 0 h 26.9 v 10.8 H 0 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2.5,2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff6604",
    d: "M 23.5 25 c 0.3 0 0.5 -0.2 0.5 -0.5 V 13.5 a 0.5 0.5 0 0 0 -0.5 -0.5 H 4.5 a 0.5 0.5 0 0 0 -0.5 0.5 v 11.1 c 0 0.3 0.2 0.5 0.5 0.5 c 0.3 0 0.5 -0.2 0.5 -0.5 V 13.9 h 5.5 v 10.6 c 0 0.3 0.2 0.5 0.5 0.5 s 0.5 -0.2 0.5 -0.5 V 13.9 H 23.1 v 10.6 c 0 0.3 0.2 0.5 0.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6604",
    d: "M 21.5 18 a 0.5 0.5 0 0 0 0.4 -0.9 l -1 -1 a 0.5 0.5 0 1 0 -0.7 0.7 l 1 1 A 0.5 0.5 0 0 0 21.5 18"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6604",
    d: "M 26.6 14.7 h -0.5 V 0.5 a 0.5 0.5 0 1 0 -0.9 0 v 14.2 h -4.5 v -2.7 h 0.5 a 0.5 0.5 0 0 0 0 -0.9 h -1.8 a 0.5 0.5 0 0 0 0 0.9 h 0.5 v 2.7 h -2.7 v -4.5 h 2.3 a 0.5 0.5 0 0 0 0 -0.9 h -5.4 a 0.5 0.5 0 0 0 0 0.9 h 2.3 v 4.5 h -2.7 v -2.7 h 0.5 a 0.5 0.5 0 0 0 0 -0.9 h -1.8 a 0.5 0.5 0 0 0 0 0.9 h 0.5 v 2.7 H 1.8 V 0.5 a 0.5 0.5 0 1 0 -0.9 0 v 14.2 H 0.5 a 0.5 0.5 0 0 0 0 0.9 h 26.1 a 0.5 0.5 0 0 0 0 -0.9",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6604",
    d: "M 26.1 9.7 a 1.8 1.8 0 0 1 -0.9 -1.6 v -5.9 a 0.5 0.5 0 1 0 -0.9 0 v 5.9 c 0 1 -0.8 1.8 -1.8 1.8 c -1 0 -1.8 -0.8 -1.8 -1.8 v -5.9 a 0.5 0.5 0 1 0 -0.9 0 v 5.9 c 0 1 -0.8 1.8 -1.8 1.8 c -1 0 -1.8 -0.8 -1.8 -1.8 v -5.9 a 0.5 0.5 0 1 0 -0.9 0 v 5.9 c 0 1 -0.8 1.8 -1.8 1.8 c -1 0 -1.8 -0.8 -1.8 -1.8 v -5.9 a 0.5 0.5 0 1 0 -0.9 0 v 5.9 c 0 1 -0.8 1.8 -1.8 1.8 c -1 0 -1.8 -0.8 -1.8 -1.8 v -5.9 a 0.5 0.5 0 1 0 -0.9 0 v 5.9 c 0 1 -0.8 1.8 -1.8 1.8 c -1 0 -1.8 -0.8 -1.8 -1.8 v -5.9 a 0.5 0.5 0 1 0 -0.9 0 v 5.9 c 0 0.7 -0.4 1.2 -0.9 1.6 V 2.3 c 0 -0.7 0.6 -1.4 1.3 -1.4 h 22.5 c 0.7 0 1.3 0.6 1.3 1.4 v 7.4 z M 24.7 0 H 2.2 A 2.3 2.3 0 0 0 0 2.3 v 8.1 a 0.5 0.5 0 0 0 0.5 0.4 a 2.7 2.7 0 0 0 1.7 -1.2 a 2.7 2.7 0 0 0 2.2 1.2 c 0.9 0 1.8 -0.5 2.2 -1.2 a 2.7 2.7 0 0 0 2.2 1.2 c 0.9 0 1.8 -0.5 2.2 -1.2 a 2.7 2.7 0 0 0 2.2 1.2 c 0.9 0 1.8 -0.5 2.2 -1.2 a 2.7 2.7 0 0 0 2.2 1.2 c 0.9 0 1.8 -0.5 2.2 -1.2 a 2.7 2.7 0 0 0 2.2 1.2 a 2.7 2.7 0 0 0 2.2 -1.2 c 0.4 0.6 1 1 1.7 1.2 a 0.4 0.4 0 0 0 0.4 -0.1 a 0.5 0.5 0 0 0 0.2 -0.3 V 2.3 A 2.3 2.3 0 0 0 24.7 0 z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e26b1f",
    d: "M 8 19.5 v 1 a 0.5 0.5 0 0 0 1 0 v -1 a 0.5 0.5 0 0 0 -1 0 M 18.1 16.1 a 0.5 0.5 0 0 0 0 0.7 l 2 2 a 0.5 0.5 0 0 0 0.7 0 a 0.5 0.5 0 0 0 0 -0.7 l -2 -2 a 0.5 0.5 0 0 0 -0.7 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarIcon);
export default __webpack_public_path__ + "static/media/bar-icon.6c3fcccf83c504c9991266c63366b9a7.svg";
export { ForwardRef as ReactComponent };